import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const OrgUserPreferencesModalLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "OrgPostingIntentionModal" */
      './OrgUserPreferencesModal.dynamic'
    ),
  loading: LoadingModal,
});
